export default __webpack_public_path__ + "static/media/planet-middle.2d458622.svg";